module.exports = __webpack_public_path__ + "static/media/student-background-side.58c1b086.png";